import BaseService from 'services/base'

export default class GlobalMessageService extends BaseService {
  constructor(api) {
    super(api)
    this.api = api

    this.handleOnApiError = this.handleOnApiError.bind(this)
    this.api.onApiError = this.handleOnApiError
  }

  handleOnApiError(result) {
    this.onApiError && this.onApiError(result)
  }

}
